import { useEffect, useRef, useState } from 'react';
import TrialEmailForm from '../forms/OnboardingForm/TrialEmailForm';

// Mobile-only (< md) sticky CTA bar. The hero's signup card is hidden below md, so this
// bar is the mobile entry point: tapping "Start free trial" slides up a bottom sheet
// holding the same TrialEmailForm.
const MobileTrialBar = ({ onSuccess }) => {
    const [open, setOpen] = useState(false);
    const sheetRef = useRef();

    useEffect(() => {
        if (!open) return;

        // Lock background scroll and allow Escape to close while the sheet is up.
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const onKeyDown = (e) => { if (e.key === 'Escape') setOpen(false); };
        window.addEventListener('keydown', onKeyDown);
        sheetRef.current?.focus();

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [open]);

    return (
        <div className="d-md-none">
            {/* Reserves room at the page bottom so the fixed bar never covers the footer. */}
            <div className="mobile-trial-spacer" aria-hidden="true"></div>

            {!open && (
                <div className="mobile-trial-bar w-100 position-fixed bottom-0 start-0 z-index-fixed d-flex align-items-center justify-content-between gap-3">
                    <div>
                        <div className=" text-sk-green fw-semi-bold">£0 today</div>
                        <div className="extra-small su-text-muted">Card required &bull; cancel anytime</div>
                    </div>
                    <button type="button" className="btn-sk-primary rounded-4 text-nowrap" onClick={() => setOpen(true)}>
                        Start free trial
                    </button>
                </div>
            )}

            {open && (
                <>
                    <div className="mobile-trial-backdrop" onClick={() => setOpen(false)} aria-hidden="true"></div>
                    <div
                        ref={sheetRef}
                        className="mobile-trial-sheet"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Start your free trial"
                        tabIndex={-1}
                    >
                        <div className="mobile-trial-handle" aria-hidden="true"></div>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="mobile-trial-close" onClick={() => setOpen(false)}>
                                Close <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <TrialEmailForm onSuccess={onSuccess} headingTag="h2" controlId="trialEmailMobile" />
                    </div>
                </>
            )}
        </div>
    );
};

export default MobileTrialBar;
